/* tslint:disable */

declare var Object: any;
export interface MedicionInterface {
  "idmedicion"?: number;
  "company"?: string;
  "emailcompany"?: string;
  "name"?: string;
  "lastname"?: string;
  "number"?: number;
  "recipeframemodel"?: string;
  "recipeframepicture"?: string;
  "reciperecipepicture"?: string;
  "reciperecipe"?: string;
  "image"?: string;
  "resultmarkersleft1"?: number;
  "resultmarkersleft2"?: number;
  "resultmarkersright1"?: number;
  "resultmarkersright2"?: number;
  "resultpupilsleft1"?: number;
  "resultpupilsleft2"?: number;
  "resultpupilsright1"?: number;
  "resultpupilsright2"?: number;
  "resultframetopleft1"?: number;
  "resultframetopleft2"?: number;
  "resultframetopright1"?: number;
  "resultframetopright2"?: number;
  "resultframebotleft1"?: number;
  "resultframebotleft2"?: number;
  "resultframebotright1"?: number;
  "resultframebotright2"?: number;
  "resultnosebridgetop1"?: number;
  "resultnosebridgetop2"?: number;
  "resultnosebridgebot1"?: number;
  "resultnosebridgebot2"?: number;
  "resultmmcameradistance"?: number;
  "resultpxmarkersdistance"?: string;
  "resultpxpupilsdistance"?: string;
  "resultpxleftpupiltobridge"?: string;
  "resultpxrightpupiltobridge"?: string;
  "resultpxleftpupiltotopframe"?: string;
  "resultpxleftpupiltobotframe"?: string;
  "resultpxrightpupiltotopframe"?: string;
  "resultpxrightpupiltobotframe"?: string;
  "resultmmtotalpupildistance"?: string;
  "resultmmmarkersdistance"?: string;
  "resultmmpupilsdistance"?: string;
  "resultmmleftpupiltobridge"?: string;
  "resultmmrightpupiltobridge"?: string;
  "resultmmleftpupiltotopframe"?: string;
  "resultmmleftpupiltobotframe"?: string;
  "resultmmrightpupiltotopframe"?: string;
  "resultmmrightpupiltobotframe"?: string;
  "created"?: Date;
  "avatar"?: string;
  "empresaid": number;
  "state": number;
  "empresa": string;
  "idMongo"?: string;
  "nrosobre"?: string;
  "nroarreglo"?: string;
}

export class Medicion implements MedicionInterface {
  "idmedicion": number;
  "company": string;
  "emailcompany": string;
  "name": string;
  "lastname": string;
  "number": number;
  "recipeframemodel": string;
  "recipeframepicture": string;
  "reciperecipepicture": string;
  "reciperecipe": string;
  "image": string;
  "resultmarkersleft1": number;
  "resultmarkersleft2": number;
  "resultmarkersright1": number;
  "resultmarkersright2": number;
  "resultpupilsleft1": number;
  "resultpupilsleft2": number;
  "resultpupilsright1": number;
  "resultpupilsright2": number;
  "resultframetopleft1": number;
  "resultframetopleft2": number;
  "resultframetopright1": number;
  "resultframetopright2": number;
  "resultframebotleft1": number;
  "resultframebotleft2": number;
  "resultframebotright1": number;
  "resultframebotright2": number;
  "resultnosebridgetop1": number;
  "resultnosebridgetop2": number;
  "resultnosebridgebot1": number;
  "resultnosebridgebot2": number;
  "resultmmcameradistance": number;
  "resultpxmarkersdistance": string;
  "resultpxpupilsdistance": string;
  "resultpxleftpupiltobridge": string;
  "resultpxrightpupiltobridge": string;
  "resultpxleftpupiltotopframe": string;
  "resultpxleftpupiltobotframe": string;
  "resultpxrightpupiltotopframe": string;
  "resultpxrightpupiltobotframe": string;
  "resultmmtotalpupildistance": string;
  "resultmmmarkersdistance": string;
  "resultmmpupilsdistance": string;
  "resultmmleftpupiltobridge": string;
  "resultmmrightpupiltobridge": string;
  "resultmmleftpupiltotopframe": string;
  "resultmmleftpupiltobotframe": string;
  "resultmmrightpupiltotopframe": string;
  "resultmmrightpupiltobotframe": string;
  "created": Date;
  "avatar": string;
  "empresaid": number;
  "state": number;
  "empresa": string;
  "idMongo": string;
  "nrosobre": string;
  "nroarreglo": string;
  "idestado": string;



  "odEsferica": number;
  "odCilindro": number;
  "odEje": number;
  "oiEsferica": number;
  "oiCilindro": number;
  "oiEje": number;
  "addDerecho": number;
  "oddDerecho": number;
  "addIzquierdo": number;
  "oddIzquierdo": number;
  constructor(data?: MedicionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Medicion`.
   */
  public static getModelName() {
    return "Medicion";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Medicion for dynamic purposes.
  **/
  public static factory(data: MedicionInterface): Medicion {
    return new Medicion(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Medicion',
      plural: 'Medicions',
      path: 'Medicions',
      idName: 'idmedicion',
      properties: {
        "idmedicion": {
          name: 'idmedicion',
          type: 'number'
        },
        "company": {
          name: 'company',
          type: 'string'
        },
        "emailcompany": {
          name: 'emailcompany',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "lastname": {
          name: 'lastname',
          type: 'string'
        },
        "number": {
          name: 'number',
          type: 'number'
        },
        "recipeframemodel": {
          name: 'recipeframemodel',
          type: 'string'
        },
        "recipeframepicture": {
          name: 'recipeframepicture',
          type: 'string'
        },
        "reciperecipepicture": {
          name: 'reciperecipepicture',
          type: 'string'
        },
        "reciperecipe": {
          name: 'reciperecipe',
          type: 'string'
        },
        "image": {
          name: 'image',
          type: 'string'
        },
        "resultmarkersleft1": {
          name: 'resultmarkersleft1',
          type: 'number'
        },
        "resultmarkersleft2": {
          name: 'resultmarkersleft2',
          type: 'number'
        },
        "resultmarkersright1": {
          name: 'resultmarkersright1',
          type: 'number'
        },
        "resultmarkersright2": {
          name: 'resultmarkersright2',
          type: 'number'
        },
        "resultpupilsleft1": {
          name: 'resultpupilsleft1',
          type: 'number'
        },
        "resultpupilsleft2": {
          name: 'resultpupilsleft2',
          type: 'number'
        },
        "resultpupilsright1": {
          name: 'resultpupilsright1',
          type: 'number'
        },
        "resultpupilsright2": {
          name: 'resultpupilsright2',
          type: 'number'
        },
        "resultframetopleft1": {
          name: 'resultframetopleft1',
          type: 'number'
        },
        "resultframetopleft2": {
          name: 'resultframetopleft2',
          type: 'number'
        },
        "resultframetopright1": {
          name: 'resultframetopright1',
          type: 'number'
        },
        "resultframetopright2": {
          name: 'resultframetopright2',
          type: 'number'
        },
        "resultframebotleft1": {
          name: 'resultframebotleft1',
          type: 'number'
        },
        "resultframebotleft2": {
          name: 'resultframebotleft2',
          type: 'number'
        },
        "resultframebotright1": {
          name: 'resultframebotright1',
          type: 'number'
        },
        "resultframebotright2": {
          name: 'resultframebotright2',
          type: 'number'
        },
        "resultnosebridgetop1": {
          name: 'resultnosebridgetop1',
          type: 'number'
        },
        "resultnosebridgetop2": {
          name: 'resultnosebridgetop2',
          type: 'number'
        },
        "resultnosebridgebot1": {
          name: 'resultnosebridgebot1',
          type: 'number'
        },
        "resultnosebridgebot2": {
          name: 'resultnosebridgebot2',
          type: 'number'
        },
        "resultmmcameradistance": {
          name: 'resultmmcameradistance',
          type: 'number'
        },
        "resultpxmarkersdistance": {
          name: 'resultpxmarkersdistance',
          type: 'string'
        },
        "resultpxpupilsdistance": {
          name: 'resultpxpupilsdistance',
          type: 'string'
        },
        "resultpxleftpupiltobridge": {
          name: 'resultpxleftpupiltobridge',
          type: 'string'
        },
        "resultpxrightpupiltobridge": {
          name: 'resultpxrightpupiltobridge',
          type: 'string'
        },
        "resultpxleftpupiltotopframe": {
          name: 'resultpxleftpupiltotopframe',
          type: 'string'
        },
        "resultpxleftpupiltobotframe": {
          name: 'resultpxleftpupiltobotframe',
          type: 'string'
        },
        "resultpxrightpupiltotopframe": {
          name: 'resultpxrightpupiltotopframe',
          type: 'string'
        },
        "resultpxrightpupiltobotframe": {
          name: 'resultpxrightpupiltobotframe',
          type: 'string'
        },
        "resultmmtotalpupildistance": {
          name: 'resultmmtotalpupildistance',
          type: 'string'
        },
        "resultmmmarkersdistance": {
          name: 'resultmmmarkersdistance',
          type: 'string'
        },
        "resultmmpupilsdistance": {
          name: 'resultmmpupilsdistance',
          type: 'string'
        },
        "resultmmleftpupiltobridge": {
          name: 'resultmmleftpupiltobridge',
          type: 'string'
        },
        "resultmmrightpupiltobridge": {
          name: 'resultmmrightpupiltobridge',
          type: 'string'
        },
        "resultmmleftpupiltotopframe": {
          name: 'resultmmleftpupiltotopframe',
          type: 'string'
        },
        "resultmmleftpupiltobotframe": {
          name: 'resultmmleftpupiltobotframe',
          type: 'string'
        },
        "resultmmrightpupiltotopframe": {
          name: 'resultmmrightpupiltotopframe',
          type: 'string'
        },
        "resultmmrightpupiltobotframe": {
          name: 'resultmmrightpupiltobotframe',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date'
        },
        "avatar": {
          name: 'avatar',
          type: 'string'
        },
        "empresaid": {
          name: 'empresaid',
          type: 'number'
        },
        "state": {
          name: 'state',
          type: 'number'
        },
        "empresa": {
          name: 'empresa',
          type: 'string'
        },
        "idMongo": {
          name: 'idMongo',
          type: 'string'
        }, "nrosobre": {
          name: 'nrosobre',
          type: 'string'
        }, "nroarreglo": {
          name: 'nroarreglo',
          type: 'string'
        }, "odEsferica": {
          name: 'odEsferica',
          type: 'number'
        }, "odCilindro": {
          name: 'odCilindro',
          type: 'number'
        }, "odEje": {
          name: 'odEje',
          type: 'number'
        }, "oiEsferica": {
          name: 'oiEsferica',
          type: 'number'
        }, "oiCilindro": {
          name: 'oiCilindro',
          type: 'number'
        }, "oiEje": {
          name: 'oiEje',
          type: 'number'
        }, "addDerecho": {
          name: 'addDerecho',
          type: 'number'
        }, "oddDerecho": {
          name: 'oddDerecho',
          type: 'number'
        }, "addIzquierdo": {
          name: 'addIzquierdo',
          type: 'number'
        }, "oddIzquierdo": {
          name: 'oddIzquierdo',
          type: 'number'
        }

      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/models/Medicion.ts